import { useIsMdDown } from '@/hooks/useMedia';

import type { Watch } from '../../MyWatchesView';
import { MyWatchesGrid, MyWatchesSlider } from './components';
import { sortWatches } from './helpers';

export interface MyWatchesListProps {
  onRegisterWatchClick: () => void;
  watches: Watch[];
}

export const MyWatchesList = ({
  onRegisterWatchClick,
  watches,
}: MyWatchesListProps) => {
  const isMobile = useIsMdDown();
  const sortedWatches = sortWatches(watches);

  if (isMobile && watches.length > 1) {
    return (
      <MyWatchesSlider
        data-test-id='MyWatchesList-MobilMyWatchesSlider'
        watches={sortedWatches}
      />
    );
  }

  return (
    <MyWatchesGrid
      data-test-id='MyWatchesList-MyWatchesGrid'
      onRegisterWatchClick={onRegisterWatchClick}
      watches={sortedWatches}
    />
  );
};
